import type {
  Chatbot,
  ChatbotCreateInput,
  ChatbotCreateResponse,
  ChatbotUpdateInput,
} from "@chat-yai/shared/admin-types";
import { request } from "@/api/client";

export const chatbotsApi = {
  list(query: { site_id?: string } = {}) {
    return request<{ chatbots: Chatbot[] }>("/admin/chatbots", { query });
  },
  get(id: string) {
    return request<{ chatbot: Chatbot; embed_snippet: string }>(
      `/admin/chatbots/${id}`,
    );
  },
  create(input: ChatbotCreateInput) {
    return request<ChatbotCreateResponse>("/admin/chatbots", {
      method: "POST",
      body: input,
    });
  },
  update(id: string, input: ChatbotUpdateInput) {
    return request<{ chatbot: Chatbot }>(`/admin/chatbots/${id}`, {
      method: "PATCH",
      body: input,
    });
  },
  remove(id: string) {
    return request<{ ok: true }>(`/admin/chatbots/${id}`, { method: "DELETE" });
  },
};
